import React from "react";
import "../App.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Moment from "moment";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { confirmAlert } from "react-confirm-alert";
import API from "../helpers/api";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

class MMPLPendingTaskIHM extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
    };
    this.revertItem = this.revertItem.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  updatePopover(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>Update</label>
        </Popover.Content>
      </Popover>
    );
  }
  updatePopover1(props, e) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>{e}</label>
        </Popover.Content>
      </Popover>
    );
  }

  showEditPODetailPanel = (shipId, poId) => {
    const { history, dispatch } = this.props;
    dispatch({ type: "ShowSidePan", data: false });
    history.push(`/Home/IHMPart1/${shipId}/${poId}`);
    dispatch({ type: "InventoryUploadSuccess", data: null });
    // window.open(window.location.origin + `/Home/IHMPart1/${shipId}/${poId}`, '_blank');
    window.scrollTo(0, 0);
  };
  showViewPODetailPanel = (shipId, poId) => {
    const { history, dispatch } = this.props;
    dispatch({ type: "ShowSidePan", data: false });
    history.push(`/Home/IHMPart1/${shipId}/${poId}/view`);
    dispatch({ type: "InventoryUploadSuccess", data: null });
    // window.open(window.location.origin + `/Home/IHMPart1/${shipId}/${poId}`, '_blank');
    window.scrollTo(0, 0);
  };

  showPODetailPanel = (shipId, poId) => {
    const { history, dispatch } = this.props;
    dispatch({ type: "EditPOView", data: false });
    history.push(`/Home/POView/${shipId}/${poId}`);
    window.scrollTo(0, 0);
  };
  revertItem(shipId, purchaseOrderId) {
    const {} = this.props;
    this.props.revertPoItem(purchaseOrderId);
    // confirmAlert({
    //   message: "Are you sure want to revert this PO ?",
    //   buttons: [
    //     {
    //       label: "Yes",
    //       onClick: () => {
    //         // this.props.revertPoItem(purchaseOrderId);
    //         let url = `${API.RevertPo}` + purchaseOrderId;
    //         debugger;
    //         axios
    //           .put(url)
    //           .then((response) => {
    //             console.log("tooSuceess");
    //             window.scrollTo(0, document.body.scrollHeight);
    //             // dispatch(getMMPLIHMSearchlist(this.state, this.state.PageNo));
    //             toast.success("Po Revert successfully.", {
    //               position: "top-right",
    //               autoClose: 5000,
    //               hideProgressBar: true,
    //               closeOnClick: true,
    //               pauseOnHover: true,
    //               draggable: true,
    //               progress: undefined,
    //             });
    //           })
    //           .catch((error) => {});
    //       },
    //     },
    //     {
    //       label: "No",
    //       onClick: () => {},
    //     },
    //   ],
    // });
  }

  render() {
    const { totalRecords, pageSize } = this.props;
    return (
      <div className="pb-4">
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="p-0">
              <div className="row">
                <div className="col-sm-12">{this.renderCardPendingData()}</div>
              </div>
            </div>
          </div>
        </div>

        {totalRecords !== 0 ? (
          <Paginator
            first={this.state.first}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">No Tasks</h6>
            </div>
          </div>
        )}
      </div>
    );
  }

  onPaginatorChange(event) {
    this.setState({
      first: event.first,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1);
  }

  renderCardPendingData = () => {
    const { arraylist, isViewOnly } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
          return (
            <div
              className="card"
              style={{
                overflow: "hidden",
                position: "relative",
                marginBottom: "5px",
              }}
            >
              <div className="px-3 py-2">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div className="col-sm-10 col-md-11 col-10 col-m-auto">
                      <div className="row">
                        <div className="col-sm-3 col-md-3">
                          <h6
                            className="resource-list-title mb-0"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.showPODetailPanel(
                                item.shipId,
                                item.purchaseOrderId
                              )
                            }
                          >
                            {item ? item.poNo : ""}
                          </h6>
                        </div>
                        <div className="col-sm-3 col-md-3">
                          <span>
                            <strong>PO Date : </strong>
                            <span className="italicFont">
                              {item
                                ? Moment(
                                    new Date(Date.parse(item.poDate))
                                  ).format("DD MMM YYYY")
                                : ""}
                            </span>
                          </span>
                        </div>
                        {/* <div className="col-sm-4 col-md-2 m-auto">
                        <span>
                          <strong>Quantity : </strong>
                          <span className="italicFont">{item ? item.quantity : ""}</span>
                        </span>
                      </div> */}
                        <div className="col-sm-3 col-md-3">
                          <span>
                            <strong>Ship Name : </strong>
                            <span className="italicFont ">
                              {item ? item.vesselName : ""}
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-3 col-md-3">
                          <span>
                            <strong>Last reviewed : </strong>
                            <span className="italicFont ">
                              {item
                                ? Moment(
                                    new Date(Date.parse(item.lastReviewed))
                                  ).format("DD MMM YYYY")
                                : ""}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-2 col-md-1 col-2 col-m-auto text-right">
                      {(item.isValidated ||  !item.isValidated) && !isViewOnly ? (
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={this.updatePopover()}
                        >
                          <i
                            className="fa fa-edit click"
                            aria-hidden="true"
                            style={{ color: " #1E3A8A", fontSize: "30px" }}
                            onClick={() =>
                              this.showEditPODetailPanel(
                                item.shipId,
                                item.purchaseOrderId
                              )
                            }
                          ></i>
                        </OverlayTrigger>
                      ) : (
                        <div className="row justify-content-around">
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={(e) => this.updatePopover1(e, "View")}
                          >
                            <i
                              className="fa fa-eye click"
                              aria-hidden="true"
                              style={{ color: " #1E3A8A", fontSize: "30px" }}
                              onClick={() =>
                                this.showViewPODetailPanel(
                                  item.shipId,
                                  item.purchaseOrderId
                                )
                              }
                            ></i>
                          </OverlayTrigger>
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={(e) => this.updatePopover1(e, "Revert")}
                          >
                            <i
                              className="fa fa-share fa-flip-horizontal click"
                              aria-hidden="true"
                              style={{ color: " #1E3A8A", fontSize: "30px" }}
                              onClick={() =>
                                this.props.revertPoItem(
                                  item.shipId,
                                  item.purchaseOrderId
                                )
                              }
                            ></i>
                          </OverlayTrigger>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      : null;
  };

  ShowSidePanel = (id) => {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push(`/Home/EquipmentEdit/${id}/single`);
  };

  editEquipmentDetails = (id, type) => {
    this.props.dispatch({ type: "EditEquipmentDetails", data: true });
    this.props.history.push(`/Home/ShipDetails/EquipmentEdit/${id}/${type}`);
  };
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MMPLPendingTaskIHM)
);
